"use strict";

function InitializeCollapseComponent() {
    const $collapseHeaders = $(".pd-collapse-component__header");

    const handleEvents = () => {
        $collapseHeaders.on("click", function (e) {
            e.preventDefault();

            const $button      = $(this);
            const targetId     = $button.data("target");
            const $collapseDiv = $(targetId);
            const isExpanded   = $button.attr("aria-expanded") === "true";

            if (isExpanded) {
                $collapseDiv.slideUp(300);
                $button.attr("aria-expanded", "false");
                $button.removeClass("is-active");
            } else {
                $collapseDiv.slideDown(300);
                $button.attr("aria-expanded", "true");
                $button.addClass("is-active");
            }
        });
    };

    const init = () => {
        handleEvents();
    };

    init();
}

export default InitializeCollapseComponent;
